export const factoryName = 'DANDU FINDIK';
export const lineName = 'Fındık Kırma Hattı';
export const sensorFrequencyLabel = '1 sn sensör verisi';
export const uiRefreshLabel = '2 sn UI yenileme';
export const operatorName = 'Operatör Ayşe';

export const statusChips = [
  { label: '1 Alarm', color: '#ff5f57' },
  { label: '1 Uyarı', color: '#ffb44c' },
  { label: '3 Normal', color: '#4ade80' },
  { label: '5 Makine', color: '#60a5fa' },
];

export const machines = [
  {
    id: 'kirma-makinasi-1',
    name: 'Kırma Makinası 1',
    state: 'normal',
    activeAlerts: 0,
    lastSeen: '1 sn önce',
    power: '7.4 kW',
    airflowInstant: '198 L/dk',
    airTotal: '18.400 L',
    pressure: '6.2 bar',
    temperature: '44 °C',
    humidity: '%46 RH',
    summary: 'Nominal üretim aralığında çalışıyor',
    shortStatus: 'Normal',
  },
  {
    id: 'kirma-makinasi-2',
    name: 'Kırma Makinası 2',
    state: 'normal',
    activeAlerts: 0,
    lastSeen: '1 sn önce',
    power: '7.9 kW',
    airflowInstant: '214 L/dk',
    airTotal: '19.250 L',
    pressure: '6.1 bar',
    temperature: '47 °C',
    humidity: '%49 RH',
    summary: 'Yük altında dengeli çalışıyor',
    shortStatus: 'Normal',
  },
  {
    id: 'kirma-makinasi-3',
    name: 'Kırma Makinası 3',
    state: 'alarm',
    activeAlerts: 2,
    lastSeen: '1 sn önce',
    power: '9.6 kW',
    airflowInstant: '318 L/dk',
    airTotal: '24.100 L',
    pressure: '4.8 bar',
    temperature: '58 °C',
    humidity: '%47 RH',
    summary: 'Hava akışı yüksek, basınç düşük',
    shortStatus: 'Alarm',
  },
  {
    id: 'kirma-makinasi-4',
    name: 'Kırma Makinası 4',
    state: 'warning',
    activeAlerts: 1,
    lastSeen: '2 sn önce',
    power: '8.7 kW',
    airflowInstant: '242 L/dk',
    airTotal: '20.050 L',
    pressure: '5.9 bar',
    temperature: '53 °C',
    humidity: '%52 RH',
    summary: 'Sıcaklık yükseliyor, izleme gerekli',
    shortStatus: 'Uyarı',
  },
  {
    id: 'kirma-makinasi-5',
    name: 'Kırma Makinası 5',
    state: 'normal',
    activeAlerts: 0,
    lastSeen: '1 sn önce',
    power: '7.1 kW',
    airflowInstant: '187 L/dk',
    airTotal: '17.980 L',
    pressure: '6.3 bar',
    temperature: '43 °C',
    humidity: '%45 RH',
    summary: 'Stabil üretim akışında',
    shortStatus: 'Normal',
  },
];

export const detailScenarios = {
  'kirma-makinasi-1': {
    headline: 'Makine stabil, üretim aralığı sağlıklı',
    detail: 'Basınç, hava akışı ve elektrik gücü nominal aralıkta. Alarm yok.',
    severity: 'Normal',
    severityColor: '#4ade80',
    suggestedActions: [
      'Planlı bakım takvimini koru.',
      'Vardiya sonu toplam hava tüketimini kontrol et.',
      'Rulman sıcaklığı trendini günlük rapora ekle.',
    ],
  },
  'kirma-makinasi-2': {
    headline: 'Makine yük altında ama dengeli',
    detail: 'Elektrik gücü bir miktar yüksek olsa da basınç ve sıcaklık stabil.',
    severity: 'Normal',
    severityColor: '#4ade80',
    suggestedActions: [
      'Üretim reçetesine göre yük profilini teyit et.',
      'Gün sonu enerji verimliliği raporuna dahil et.',
      'Nem dalgalanması için ortam kayıtlarını izle.',
    ],
  },
  'kirma-makinasi-3': {
    headline: 'Hava akışı yükseldi, basınç düşüyor',
    detail: 'Son 4 dakikada pnömatik hatta dengesizlik gözleniyor. Elektrik gücü ve sıcaklık da birlikte yükseliyor.',
    severity: 'Alarm',
    severityColor: '#ff5f57',
    suggestedActions: [
      'Pnömatik hat kaçak kontrolünü başlat.',
      'Regülatör çıkış basıncını ölç ve filtreyi kontrol et.',
      'Valf hattında kısmi tıkanıklık veya kaçak olup olmadığını doğrula.',
    ],
  },
  'kirma-makinasi-4': {
    headline: 'Sıcaklık yükseliyor, erken müdahale önerilir',
    detail: 'Makine halen üretimde ancak sıcaklık üst sınıra yaklaşıyor.',
    severity: 'Uyarı',
    severityColor: '#ffb44c',
    suggestedActions: [
      'Fan ve hava sirkülasyonunu kontrol et.',
      'Rulman yatağında sürtünme artışı olup olmadığını incele.',
      'Bir sonraki 15 dakikada sıcaklık trendini teyit et.',
    ],
  },
  'kirma-makinasi-5': {
    headline: 'Makine stabil, alarm yok',
    detail: 'Tüm sensörler nominal aralıkta. Operasyon akışı normal.',
    severity: 'Normal',
    severityColor: '#4ade80',
    suggestedActions: [
      'Vardiya raporuna mevcut değerleri işle.',
      'Toplam hava tüketimini referans olarak sakla.',
      'Anlık nem ve sıcaklık verilerini proses kaydına ekle.',
    ],
  },
};

export const machineDetailData = {
  'kirma-makinasi-3': {
    activeAlerts: [
      {
        id: 1,
        title: 'Kombine Pnömatik Alarm',
        severity: 'Kritik',
        severityColor: '#ff5f57',
        meta: '20 sn boyunca hava akışı > 260 L/dk ve basınç < 5.4 bar',
        status: 'Onay bekliyor • 14:32:45',
      },
      {
        id: 2,
        title: 'Sıcaklık Yükseliyor',
        severity: 'Uyarı',
        severityColor: '#ffb44c',
        meta: '60 sn ortalama sıcaklık > 55 °C',
        status: 'Operatör notu eklendi • 14:31:20',
      },
    ],
    timeline: [
      { time: '14:32', type: 'critical', label: 'Kombine pnömatik alarm tetiklendi', detail: '318 L/dk ve 4.8 bar' },
      { time: '14:30', type: 'warning', label: 'Hava akışı hızlandı', detail: '5 dakikalık ortalama 260 L/dk üstüne çıktı' },
      { time: '14:28', type: 'warning', label: 'Basınç düşüşü başladı', detail: 'Ortalama basınç 5.4 bar altına indi' },
      { time: '14:25', type: 'info', label: 'Yük yükseldi', detail: 'Elektrik gücü 8.8 kW üstüne çıktı' },
    ],
    sensorCharts: {
      pressure: {
        label: 'Basınç',
        unit: 'bar',
        color: '#ff5f57',
        thresholdLabel: 'Alt sınır 5.4 bar',
        thresholdValue: 5.4,
        values: [6.3, 6.2, 6.1, 6.0, 5.8, 5.7, 5.5, 5.3, 5.1, 4.9, 4.8, 4.8],
      },
      airflowInstant: {
        label: 'Hava Akışı',
        unit: 'L/dk',
        color: '#38bdf8',
        thresholdLabel: 'Üst sınır 260 L/dk',
        thresholdValue: 260,
        values: [205, 208, 214, 219, 228, 236, 247, 261, 278, 295, 307, 318],
      },
      power: {
        label: 'Elektrik Gücü',
        unit: 'kW',
        color: '#f59e0b',
        thresholdLabel: 'Üst sınır 8.8 kW',
        thresholdValue: 8.8,
        values: [7.6, 7.7, 7.8, 7.9, 8.0, 8.2, 8.4, 8.6, 8.8, 9.1, 9.4, 9.6],
      },
      temperature: {
        label: 'Sıcaklık',
        unit: '°C',
        color: '#fb7185',
        thresholdLabel: 'Üst sınır 55 °C',
        thresholdValue: 55,
        values: [46, 47, 47, 48, 49, 50, 51, 52, 53, 55, 57, 58],
      },
      humidity: {
        label: 'Nem',
        unit: '%RH',
        color: '#22c55e',
        thresholdLabel: null,
        thresholdValue: null,
        values: [46, 46, 47, 47, 48, 48, 47, 47, 48, 47, 47, 47],
      },
      airTotal: {
        label: 'Toplam Hava Tüketimi',
        unit: 'L',
        color: '#a78bfa',
        thresholdLabel: null,
        thresholdValue: null,
        values: [18020, 18540, 19080, 19610, 20140, 20670, 21210, 21780, 22340, 22920, 23510, 24100],
      },
    },
  },
  'kirma-makinasi-4': {
    activeAlerts: [
      {
        id: 1,
        title: 'Sıcaklık Sınır Üstüne Yaklaşıyor',
        severity: 'Uyarı',
        severityColor: '#ffb44c',
        meta: 'Son 15 dakikada sıcaklık 53 °C seviyesine çıktı',
        status: 'İzleme aktif • 14:32:10',
      },
    ],
    timeline: [
      { time: '14:32', type: 'warning', label: 'Sıcaklık üst sınıra yaklaştı', detail: '53 °C ölçüldü' },
      { time: '14:24', type: 'info', label: 'Soğutma fanı kontrol edildi', detail: 'Operatör gözlemi eklendi' },
      { time: '14:15', type: 'normal', label: 'Makine üretime devam ediyor', detail: 'Basınç ve hava akışı stabil' },
    ],
  },
};

export const chartTimes = ['14:00', '14:05', '14:10', '14:15', '14:20', '14:25', '14:30', '14:35', '14:40', '14:45', '14:50', '14:55'];

export function getMachineById(machineId) {
  return machines.find((machine) => machine.id === machineId) || machines[0];
}

export function getMachineDetail(machineId) {
  const baseMachine = getMachineById(machineId);
  const scenario = detailScenarios[machineId] || detailScenarios[baseMachine.id];
  const detail = machineDetailData[machineId] || createDefaultDetail(baseMachine);

  return {
    ...baseMachine,
    ...scenario,
    ...detail,
  };
}

function parseMetric(value) {
  return Number.parseFloat(String(value).replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, ''));
}

function rampSeries(endValue, delta, points = 12) {
  const startValue = endValue - delta;
  return Array.from({ length: points }, (_, index) => {
    const ratio = index / (points - 1);
    return Number((startValue + (endValue - startValue) * ratio).toFixed(1));
  });
}

function createDefaultDetail(machine) {
  const powerValue = parseMetric(machine.power);
  const airflowValue = parseMetric(machine.airflowInstant);
  const airTotalValue = parseMetric(machine.airTotal);
  const pressureValue = parseMetric(machine.pressure);
  const temperatureValue = parseMetric(machine.temperature);
  const humidityValue = parseMetric(machine.humidity);

  const isWarning = machine.state === 'warning';

  return {
    activeAlerts: isWarning
      ? [
          {
            id: 1,
            title: 'Erken Uyarı',
            severity: 'Uyarı',
            severityColor: '#ffb44c',
            meta: 'Trend nominal sınırın üstüne yaklaşmaya başladı',
            status: 'İzleniyor • 14:30:00',
          },
        ]
      : [],
    timeline: isWarning
      ? [
          { time: '14:30', type: 'warning', label: 'Erken uyarı oluşturuldu', detail: 'Trend üst sınıra yaklaştı' },
          { time: '14:15', type: 'info', label: 'Operasyon devam ediyor', detail: 'Sensör verileri alınmaya devam ediyor' },
        ]
      : [
          { time: '14:30', type: 'normal', label: 'Makine nominal aralıkta', detail: 'Aktif alarm bulunmuyor' },
          { time: '14:10', type: 'info', label: 'Vardiya verisi güncellendi', detail: 'Telemetri akışı sağlıklı' },
        ],
    sensorCharts: {
      pressure: {
        label: 'Basınç',
        unit: 'bar',
        color: isWarning ? '#ffb44c' : '#ff5f57',
        thresholdLabel: 'Alt sınır 5.4 bar',
        thresholdValue: 5.4,
        values: rampSeries(pressureValue, isWarning ? 0.4 : 0.1),
      },
      airflowInstant: {
        label: 'Hava Akışı',
        unit: 'L/dk',
        color: '#38bdf8',
        thresholdLabel: 'Üst sınır 260 L/dk',
        thresholdValue: 260,
        values: rampSeries(airflowValue, isWarning ? 18 : 10),
      },
      power: {
        label: 'Elektrik Gücü',
        unit: 'kW',
        color: '#f59e0b',
        thresholdLabel: 'Üst sınır 8.8 kW',
        thresholdValue: 8.8,
        values: rampSeries(powerValue, isWarning ? 0.8 : 0.4),
      },
      temperature: {
        label: 'Sıcaklık',
        unit: '°C',
        color: '#fb7185',
        thresholdLabel: 'Üst sınır 55 °C',
        thresholdValue: 55,
        values: rampSeries(temperatureValue, isWarning ? 6 : 3),
      },
      humidity: {
        label: 'Nem',
        unit: '%RH',
        color: '#22c55e',
        thresholdLabel: null,
        thresholdValue: null,
        values: rampSeries(humidityValue, 2),
      },
      airTotal: {
        label: 'Toplam Hava Tüketimi',
        unit: 'L',
        color: '#a78bfa',
        thresholdLabel: null,
        thresholdValue: null,
        values: rampSeries(airTotalValue, 2500),
      },
    },
  };
}
